
/**
 * Module dependencies.
 */

import {
  authorizationHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  id: string,
  token: string
};

/**
 * Export `removeProject`.
 */

export async function removeProject({ id, token }: Query) {
  const endpoint = getApiEndpoint('getUserProject', { id });

  try {
    const { data } = await request.delete(endpoint, {
      headers: authorizationHeader(token)
    });

    return data?.data;
  } catch (error) {
    throw handleRequestError(error);
  }
}
